export type ContactSalesOrigin =
  | "trial_banner_active"
  | "trial_banner_expired"
  | "trial_banner_project_limit"
  | "trial_guard_expired"
  | "trial_guard_project_limit"
  | "usage_dashboard_contract";

export const REQUIRED_MESSAGE_ORIGINS = new Set<ContactSalesOrigin>([
  "trial_banner_active",
  "usage_dashboard_contract",
]);

/** Origins that open with a drafted message the user can edit before sending. */
export const PREFILLED_MESSAGE_ORIGINS = new Set<ContactSalesOrigin>(["usage_dashboard_contract"]);
